"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dateRangesDefault = void 0;
const date_fns_1 = require("date-fns");
const elements_core_types_1 = require("@hydrogen/elements.core.types");
const elements_core_i18n_1 = require("@hydrogen/elements.core.i18n");
exports.dateRangesDefault = [
    {
        from: (0, date_fns_1.sub)((0, date_fns_1.startOfYear)(new Date()), { days: 0 }).toISOString(),
        to: (0, elements_core_i18n_1.formatDate)(new Date()),
        key: elements_core_types_1.TimeIntervalEnum.YTD,
    },
    {
        from: null,
        to: (0, elements_core_i18n_1.formatDate)(new Date()),
        key: elements_core_types_1.TimeIntervalEnum.SINCE_INCEPTION,
    },
    {
        from: (0, elements_core_i18n_1.formatDate)((0, date_fns_1.sub)((0, date_fns_1.addMonths)(new Date(), -3), { days: 1 })),
        to: (0, elements_core_i18n_1.formatDate)(new Date()),
        key: elements_core_types_1.TimeIntervalEnum.MONTHS3,
    },
    {
        from: (0, elements_core_i18n_1.formatDate)((0, date_fns_1.sub)((0, date_fns_1.addMonths)(new Date(), -6), { days: 1 })),
        to: (0, elements_core_i18n_1.formatDate)(new Date()),
        key: elements_core_types_1.TimeIntervalEnum.MONTHS6,
    },
    {
        from: (0, elements_core_i18n_1.formatDate)((0, date_fns_1.sub)((0, date_fns_1.addYears)(new Date(), -1), { days: 1 })),
        to: (0, elements_core_i18n_1.formatDate)(new Date()),
        key: elements_core_types_1.TimeIntervalEnum.YEARS1,
    },
    {
        from: (0, elements_core_i18n_1.formatDate)((0, date_fns_1.sub)((0, date_fns_1.addYears)(new Date(), -3), { days: 1 })),
        to: (0, elements_core_i18n_1.formatDate)(new Date()),
        key: elements_core_types_1.TimeIntervalEnum.YEARS3,
    },
    {
        from: (0, elements_core_i18n_1.formatDate)((0, date_fns_1.sub)((0, date_fns_1.addYears)(new Date(), -5), { days: 1 })),
        to: (0, elements_core_i18n_1.formatDate)(new Date()),
        key: elements_core_types_1.TimeIntervalEnum.YEARS5,
    },
];
//# sourceMappingURL=date-ranges.js.map